import { useEffect } from "react";
import { useReducedMotion } from "framer-motion";

export default function SmoothScrollRuntime() {
  const reduce = useReducedMotion();

  useEffect(() => {
    if (reduce) return;
    if (!window.matchMedia("(min-width: 768px) and (hover: hover) and (pointer: fine)").matches) return;
    let lenis;
    let frame;
    let alive = true;

    import("lenis").then(({ default: Lenis }) => {
      if (!alive) return;
      lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
      const loop = (time) => {
        lenis.raf(time);
        frame = window.requestAnimationFrame(loop);
      };
      frame = window.requestAnimationFrame(loop);
    });

    return () => {
      alive = false;
      if (frame) window.cancelAnimationFrame(frame);
      lenis?.destroy?.();
    };
  }, [reduce]);

  return null;
}

